export default __webpack_public_path__ + "static/agency_kbsi-b5822971251a1c992d21a447291c2b21.jpg";